import { FC, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { Formik } from "formik";
import { t } from "i18next";
import * as Yup from "yup";
import TableListUsersActivitys from "@/shared/components/organisms/TableListUsersActivitys";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { FiltersCalendar } from "@/shared/components/organisms/FiltersCalendar";
import TableListFestivos from "@/shared/components/organisms/TableListFestivos";
import { InputDropDownSpan } from "@/shared/components/atoms/InputDropDownSpan";
import TableListGrupos from "@/shared/components/organisms/TableListGrupos";
import { SelectColor } from "../../shared/components/organisms/SelectColor";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { CheckBoxDays } from "../../shared/components/atoms/CheckBoxDays";
import TableListBonos from "@/shared/components/organisms/TableListBonos";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { ToggleText } from "@/shared/components/organisms/ToggleText";
import { Calendar } from "@/shared/components/organisms/Calendar";
import { ModalXXL } from "@/shared/components/organisms/ModalXXL";
import { Select } from "@/shared/components/organisms/Select";
import { toasts } from "@/shared/utils/toasts";

import { selectBranch } from "@/app/branchs/branch.slice";

import { Slot } from "@/app/slots/slots";

import {
  useCreateGroupMutation,
  useCreateSlotBondMutation,
  useCreateSlotNewMutation,
  useDeactivateSlotBondMutation,
  useDeleteGroupMutation,
  useDeleteSlotBondGroupMutation,
  useDeleteSlotMutation,
  useEnableSlotBondMutation,
  useGetListGroupsQuery,
  useGetSlotsBondGroupsQuery,
  useSlotsQuery,
  useUpdateGroupMutation,
  useUpdateSlotBondMutation,
  useUpdateSlotNewMutation,
} from "@/app/slots/slots.api";
import {
  useCreateHolidayMutation,
  useDeleteHolidayMutation,
  useHolidaysQuery,
  useUpdateHolidayMutation,
} from "@/app/holidays/holidays.api";
import { useFeesMutation } from "@/app/fees/fees.api";

import {
  SlotsTimesValues,
  slotsTimesInitialValues,
  slotsTimesValidationSchema,
  createSlotNewInitialValues,
  createSlotNewValidationSchema,
  holidaysInitialValues,
  holidaysValidationSchema,
} from "@/shared/schemas/slots.schema";
import { CreateRoomValues } from "@/shared/schemas/rooms.schema";
import { colors, currencies } from "@/app/fees/fees";

import { useSlotsPlacesQuery, useBondGroupsQuery } from "@/app/slots/slots.api";

import { useUpdateHoursMutation } from "@/app/branchs/branchs.api";
import { PlusCircleIcon, Trash2Icon } from "lucide-react";
import { FIELD_REQUIRED_MESSAGE } from "@/shared/utils/validations";
import AlertErrorButtons from "@/shared/components/molecules/AlertErrorButtons";
import { Modal } from "@/shared/components/organisms/Modal";
import { Input } from "@/shared/components/atoms/Input";
import { Permission, usePermission } from "@/shared/hooks/usePermission";

const optionSelectFestivos = [
  { id: 1, name: "Local" },
  { id: 2, name: "Provincial" },
  { id: 3, name: "Nacional" },
  { id: 4, name: "Mundial" },
];

const optionsTableUsers = [
  {
    id: 1,
    image: "https://picsum.photos/500",
    name: "Usuario 1",
    email: "user1@gmail.com",
    phone: "12345678",
    state: "Activo",
  },
  {
    id: 2,
    image: "https://picsum.photos/500",
    name: "Usuario 2",
    email: "user2@gmail.com",
    phone: "12345678",
    state: "En espera",
  },
];

const initialValuesSlotBond = {
  type_slot: false,
  name: "",
  description: "",
  price: "",
  currency: "",
  branch_slot_bond: false,
  session: "",
  days: "",
  repeated_bonus: false,
  max_session: "",
  nameGroupBond: "",
  groupbond_id: "",
};

export const slotBondValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  description: Yup.string().optional(),
  price: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  currency: Yup.string().required(FIELD_REQUIRED_MESSAGE),

  session: Yup.number()
    .nullable()
    .when("type_slot", {
      is: false, // 👈 solo valido si es slot normal
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional().nullable(),
    }),

  days: Yup.string().optional().nullable(),

  max_session: Yup.string()
    .nullable()
    .when(["repeated_bonus", "type_slot"], {
      is: (repeated_bonus: boolean, type_slot: boolean) =>
        repeated_bonus === true && type_slot === false, // 👈 solo valido si no es type_slot
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional().nullable(),
    }),

  nameGroupBond: Yup.string().optional().nullable(),

  groupbond_id: Yup.number()
    .nullable()
    .when("type_slot", {
      is: false, // 👈 si es un bono de grupo (no type_slot)
      then: (schema) =>
        schema.when("nameGroupBond", {
          is: (val: string | null | undefined) => !val || val.trim() === "",
          then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
          otherwise: (schema) => schema.optional(),
        }),
      otherwise: (schema) => schema.optional().nullable(),
    }),

  type_slot: Yup.boolean().optional(),
  branch_slot_bond: Yup.boolean().optional(),
  repeated_bonus: Yup.boolean().optional(),
});

export const ReservaEspacios: FC<any> = () => {
  const { id } = useParams();
  const { can } = usePermission();
  const branch = useSelector(selectBranch);
  const [checkAllEvents, setCheckAllEvents] = useState(false);

  const [slotsTimesValues, setSlotsTimesValues] = useState({
    type: "slots",
    hours: 0,
  });

  useEffect(() => {
    if (branch) {
      setSlotsTimesValues({
        ...slotsTimesValues,
        hours: branch.cancellation_slots,
      });
    }
  }, [branch]);

  const [updateBranchHours, updateBranchHourssResult] =
    useUpdateHoursMutation();

  useEffect(() => {
    if (updateBranchHourssResult.isSuccess) {
      toasts.success(
        "Actualización exitosa",
        "Los tiempos se han actualizado correctamente"
      );
    }
    if (updateBranchHourssResult.isError) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar los tiempos"
      );
    }
  }, [updateBranchHourssResult]);

  const [currentHolidayEdit, setCurrentHolidayEdit] = useState<any>();
  const [currentEventEdit, setCurrentEventEdit] = useState<Slot | undefined>();
  const [currentEventToDelete, setCurrentEventToDelete] = useState<
    Slot["id"] | undefined
  >();
  const [openDeleteEvent, setOpenDeleteEvent] = useState(false);
  const [deleteAllEvents, setDeleteAllEvents] = useState(false);
  const [currentEvent, setCurrentEvent] = useState<Slot | undefined>();
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [currentGroupEdit, setCurrentGroupEdit] = useState<any>();
  const [currentBondEdit, setCurrentBondEdit] = useState<any>();
  const [showAlertBondEdit, setShowAlertBondEdit] = useState(false);
  const [showAlertBondDelete, setShowAlertBondDelete] = useState(false);

  const slotBondsQuery = useGetSlotsBondGroupsQuery({ branchId: id });
  const [deleteSlotBondGroup] = useDeleteSlotBondGroupMutation();
  const [deactivateSlotBond] = useDeactivateSlotBondMutation();
  const [enableSlotBond] = useEnableSlotBondMutation();
  const slotsQuery = useSlotsQuery({
    branchId: id,
    groups: selectedGroups.map((group) => group.name),
    //date_start: initialDate.date_start,
    //date_end: initialDate.date_end,
  });

  const [createSlotNew] = useCreateSlotNewMutation(); // create slot new
  const [updateSlotNew] = useUpdateSlotNewMutation(); // update slot new
  const [createGroup, createGroupResult] = useCreateGroupMutation();
  const [updateGroup, updateGroupResult] = useUpdateGroupMutation();
  const [deleteGroup, deleteGroupResult] = useDeleteGroupMutation();

  const [deleteSlot, deleteSlotResult] = useDeleteSlotMutation();
  const [createSlotBond, createSlotBondResult] = useCreateSlotBondMutation();
  const [updateSlotBond, updateSlotBondResult] = useUpdateSlotBondMutation();
  const holidaysQuery = useHolidaysQuery({ branchId: id });
  const [createHoliday, createHolidayResult] = useCreateHolidayMutation();
  const [updateHoliday, updateHolidayResult] = useUpdateHolidayMutation();
  const [deleteHoliday, deleteHolidayResult] = useDeleteHolidayMutation();
  const [currentGroupToDeleteId, setCurrentGroupToDeleteId] = useState<
    number | null
  >(null);
  const [openDeleteGroup, setOpenDeleteGroup] = useState(false);
  const handleOpenDeleteGroup = (id: number) => {
    setCurrentGroupToDeleteId(id);
    setOpenDeleteGroup(!openDeleteGroup);
  };

  const [getterFees, getterFeesResult] = useFeesMutation();

  useEffect(() => {
    if (id) {
      getterFees({
        branchId: id,
      });
    }
  }, [id]);

  const slotsPlacesQuery = useSlotsPlacesQuery({ branchId: id });
  const listGroupsQuery = useGetListGroupsQuery({ branchId: id });
  const slotsBondGroupsQuery = useBondGroupsQuery({ branchId: id });

  const handleEventClick = (event: Slot) => {
    setCurrentEvent(event);
  };

  //OPEN FOR FILTERS
  const [filters, setFilters] = useState(false);
  const filtersOpen = () => {
    setFilters(!filters);
  };
  //OPEN DIALOG CREATE
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const [openDialogEditSlot, setOpenDialogEditSlot] = useState(false);
  const functionOpenDialogCreate = () => {
    setOpenDialogCreate(!openDialogCreate);
  };

  const functionOpenDialogEditSlot = () => {
    setOpenDialogEditSlot(!openDialogEditSlot);
  };

  const [openDialogEditBond, setOpenDialogEditBond] = useState(false);
  const functionOpenDialogEditBond = () => {
    setOpenDialogEditBond(!openDialogEditBond);
  };

  //OPEN DIALOG TIEMPOS
  const [openDialogTime, setOpenDialogTime] = useState(false);
  const functionOpenDialogTime = () => {
    setOpenDialogTime(!openDialogTime);
  };
  //OPEN MODAL FESTIVOS
  const [openModalFestivos, setOpenModalFestivos] = useState(false);
  const functionOpenModalFestivos = () => {
    setOpenModalFestivos(!openModalFestivos);
  };
  //OPEN DIALOG FESTIVOS
  const [openDialogFestivos, setOpenDialogFestivos] = useState(false);
  const functionOpenDialogFestivos = () => {
    setOpenDialogFestivos(!openDialogFestivos);
  };

  const [openDialogEditFestivos, setOpenDialogEditFestivos] = useState(false);
  const functionOpenDialogEditFestivos = () => {
    setOpenDialogEditFestivos(!openDialogEditFestivos);
  };

  //OPEN MODAL GRUPOS
  const [openModalGrupos, setOpenModalGrupos] = useState(false);
  const functionOpenModalGrupos = () => {
    setOpenModalGrupos(!openModalGrupos);
  };

  //OPEN MODAL ACTIVIDADES
  const [openModalActividades, setOpenModalActividades] = useState(false);
  const functionOpenModalActividades = () => {
    setOpenModalActividades(!openModalActividades);
  };

  // OPEN DIALOG CREATE GRUPOS
  const [openDialogGrupos, setOpenDialogGrupos] = useState(false);
  const functionOpenDialogGrupos = () => {
    setOpenDialogGrupos(!openDialogGrupos);
  };

  //OPEN MODAL BONOS
  const [openModalBonos, setOpenModalBonos] = useState(false);
  const functionOpenModalBonos = () => {
    setOpenModalBonos(!openModalBonos);
  };
  //OPEN DIALOG CREATE BONOS
  const [openDialogCreateBonos, setOpenDialogCreateBonos] = useState(false);
  const functionOpenDialogCreateBonos = () => {
    setOpenDialogCreateBonos(!openDialogCreateBonos);
  };

  const slotBondGroups = useMemo(() => {
    const groups =
      slotBondsQuery.data?.map((slotBond) => ({
        id: slotBond?.slot_bond_group_id,
        name: slotBond?.slot_bond_group?.name,
        groupbond: { name: slotBond?.slot_bond_group?.name },
      })) ?? [];

    const unique = [
      ...new Map(groups.map((item) => [item.name, item])).values(),
    ];

    return unique.filter((item) => Boolean(item?.name));
  }, [slotBondsQuery.data]);

  const handleActivateDeactivateBond = async (
    bondId: string,
    isEnable?: boolean
  ) => {
    try {
      if (isEnable) {
        await deactivateSlotBond({
          branchId: id,
          bondId: bondId,
        }).unwrap();
      } else {
        await enableSlotBond({
          branchId: id,
          bondId: bondId,
        }).unwrap();
      }

      toasts.success(
        "Actualización exitosa",
        "El bono se ha actualizado correctamente"
      );
      functionOpenModalBonos();
      slotBondsQuery.refetch();
    } catch (error) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar el bono"
      );
    }
  };

  const handleUpdateSlot = async (values: any) => {
    try {
      const finalData = {
        ...values,
        price: values?.price ? values?.price : 0,
        type_slot: values?.type_slot ? "on" : "off",
        fee_ids: values?.fee_ids
          ? values?.fee_ids.split(",").map((fee) => +fee)
          : [],
        slot_bond_group_ids: values?.slot_bond_group_ids
          .split(",")
          .map((bono) => +bono)
          .filter(Boolean),
        start_time: values?.start_time ? values.start_time.slice(0, 5) : "",
        branchId: id,
      };
      await updateSlotNew({
        ...finalData,
        slotId: currentEventEdit.id,
        all: checkAllEvents,
      }).unwrap();
      toasts.success(
        "Actualización exitosa",
        "La sesión se ha actualizado correctamente"
      );
    } catch (error) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar la sesión"
      );
      console.log("error", error);
      throw error;
    }
  };

  const handleCreateSlot = async (values: any) => {
    try {
      const finalData = {
        ...values,
        price: values?.price ? values?.price : 0,
        type_slot: values?.type_slot ? "on" : "off",
        slot_bond_group_ids: values?.slot_bond_group_ids
          .split(",")
          .map((bono) => +bono),
        fee_ids: values?.fee_ids
          ? values?.fee_ids.split(",").map((fee) => +fee)
          : "",
        branchId: id,
      };

      await createSlotNew({
        ...finalData,
      }).unwrap();
      toasts.success(
        "Registro exitoso",
        "La sesión se ha registrado correctamente"
      );
    } catch (error) {
      toasts.danger(
        "Error al registrar",
        "Ha ocurrido un error al registrar el espacio"
      );
      console.log("error", error);
    }
  };

  const handleDeleteBondGroupSlot = async () => {
    try {
      await deleteSlotBondGroup({
        branchId: id,
        bondId: currentBondEdit?.id,
      }).unwrap();
      setShowAlertBondDelete(false);
      toasts.success(
        "Eliminación exitosa",
        "El bono se ha eliminado correctamente"
      );
      slotBondsQuery.refetch();
    } catch (error) {
      toasts.danger(
        "Error al eliminar",
        "Ha ocurrido un error al eliminar el bono"
      );
      throw error;
    }
  };

  const slotsQueryMemo = useMemo(() => {
    return slotsQuery.data?.map((slot) => {
      return {
        ...slot,
        name: slot?.slotPlace?.name || "",
        color: slot?.slotPlace?.slotGroup?.color,
      };
    });
  }, [slotsQuery.data]);

  return (
    <div className="flex flex-col items-center h-full w-full p-2">
      <div className="flex flex-col w-full h-full">
        <Calendar
          initialDateTime={DateTime.now()}
          events={slotsQueryMemo ?? []}
          loading={slotsQuery.isLoading || slotsQuery.isFetching}
          onEventClick={handleEventClick}
          functionButtonTime={functionOpenDialogTime}
          filtersOpen={filtersOpen}
          functionButtonTopCreate={functionOpenDialogCreate}
          functionOpenModalFestivos={functionOpenModalFestivos}
          functionOpenModalGrupos={functionOpenModalGrupos}
          functionOpenModalActividades={functionOpenModalActividades}
          functionOpenModalBonos={functionOpenModalBonos}
          canCreateActivity={can(Permission.BRANCH_ACCESS_CREATE_SPACES)}
          canEditTimesActivity={can(
            Permission.BRANCH_ACCESS_EDIT_TIMES_IN_SPACES
          )}
          canEditHolidaysActivity={can(
            Permission.BRANCH_ACCESS_EDIT_HOLIDAYS_IN_SPACES
          )}
        />

        {/*DIALOG CREATE NUEVA DISPONIBILIDADAD */}
        <Formik
          initialValues={
            currentEventEdit
              ? {
                  date_start: currentEventEdit?.startDate,
                  date_end: currentEventEdit?.endDate,
                  slot_bond_group_ids: currentEventEdit?.bondIds?.join(","),
                  fee_ids: currentEventEdit?.fees?.join(","),
                  day: currentEventEdit?.day,
                  days: currentEventEdit?.days,
                  slot_place_id: currentEventEdit?.slotPlaceId,
                  duration: currentEventEdit?.duration,
                  price: currentEventEdit?.price || "",
                  type_slot: Boolean(currentEventEdit?.wallet),
                  start_time: currentEventEdit?.startTime,
                  all: currentEventEdit?.all,
                }
              : createSlotNewInitialValues
          }
          validationSchema={createSlotNewValidationSchema}
          enableReinitialize
          onSubmit={async (values, formikHelper) => {
            try {
              if (currentEventEdit) {
                await handleUpdateSlot(values);
                setCurrentEvent(undefined);
              } else {
                await handleCreateSlot(values);
              }
              formikHelper.resetForm();
              setOpenDialogCreate(false);
              setCurrentEventEdit(undefined);
              setCheckAllEvents(false);
              await slotsPlacesQuery.refetch();
              await slotsQuery.refetch();
            } catch (error) {
              console.log("error", error);
            }
          }}
        >
          {({
            handleChange,
            values,
            handleSubmit,
            errors,
            setFieldValue,
            resetForm,
            handleBlur,
            isSubmitting,
            touched,
          }) => (
            <DialogCreate
              open={openDialogCreate}
              setOpen={functionOpenDialogCreate}
              tittle={
                currentEventEdit
                  ? t("slots.views.edit_slot_title")
                  : t("slots.views.slot_title")
              }
              subTittle={t("slots.views.create_slot_title")}
              tittleButtonCreate={
                currentEventEdit ? t("general.edit") : t("general.create")
              }
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              isLoading={isSubmitting || slotsPlacesQuery.isLoading}
              OnclickCancel={() => {
                functionOpenDialogCreate();
                resetForm();
                setCheckAllEvents(false);
              }}
              onClose={() => {
                setCurrentEventEdit(undefined);
                resetForm();
                setOpenDialogCreate(false);
                setCheckAllEvents(false);
              }}
            >
              <form>
                {JSON.stringify(values.fee_ids)}
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("slots.views.caracteristics")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full flex justify-center">
                          <ToggleText
                            checked={values?.type_slot || false}
                            onChange={() => {
                              setFieldValue("type_slot", !values?.type_slot);
                            }}
                            texto={
                              values?.type_slot === false
                                ? t("slots.views.session")
                                : t("slots.views.monedero")
                            }
                            textoSecondary=""
                          />
                        </div>
                        <div className="col-span-full">
                          <Select
                            span={t("general.mandatory")}
                            error={
                              touched?.slot_place_id &&
                              (errors?.slot_place_id as unknown as boolean)
                            }
                            selected={slotsPlacesQuery.data?.find(
                              (space) => space?.id == values?.slot_place_id
                            )}
                            setSelected={(selected) => {
                              setFieldValue("slot_place_id", selected?.id);
                            }}
                            options={slotsPlacesQuery.data ?? []}
                            tittle={t("slots.views.space")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("slots.views.price")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <MultiSelect
                            selectedOptions={getterFeesResult?.data?.filter(
                              (fee) => {
                                const feesIds = values?.fee_ids
                                  ?.split(",")
                                  .map((fee) => Number(fee));

                                return feesIds?.includes(fee.id);
                              }
                            )}
                            setSelectedOptions={(selected) => {
                              setFieldValue(
                                "fee_ids",
                                selected?.map((fee) => fee.id).join(",")
                              );
                            }}
                            options={getterFeesResult?.data ?? []}
                            title={t("lesson.views.fees")}
                            textDescribe="Cuota(s) que pueden reservar gratuitamente"
                          />
                        </div>
                        {!values?.type_slot ? (
                          <div className="col-span-full">
                            <MultiSelect
                              selectedOptions={
                                slotsBondGroupsQuery?.data?.filter((bono) => {
                                  if (!values.slot_bond_group_ids) return false;

                                  const ids = values.slot_bond_group_ids
                                    .split(",")
                                    .map((id) => Number(id.trim()))
                                    .filter(Boolean); // elimina NaN

                                  return ids.includes(bono.id);
                                }) ?? []
                              }
                              setSelectedOptions={(selected) => {
                                setFieldValue(
                                  "slot_bond_group_ids",
                                  Array.isArray(selected) && selected.length > 0
                                    ? selected.map((bono) => bono.id).join(",")
                                    : ""
                                );
                              }}
                              options={slotsBondGroupsQuery?.data ?? []}
                              title={t("slots.views.bond_group")}
                              textDescribe=""
                            />
                          </div>
                        ) : (
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("slots.views.price")}
                              error={touched?.price && errors?.price}
                              textError={errors?.price}
                              value={values?.price}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="price"
                              type="text"
                              span={t("general.mandatory")}
                              placeholder={t("slots.views.price")}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("slots.views.calendaring")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <CheckBoxDays
                            value={
                              values.day && !checkAllEvents
                                ? [values.day]
                                : values.days
                            }
                            onChange={(days: string[]) => {
                              const lastDay = days[days.length - 1];
                              if (values.day && !checkAllEvents) {
                                setFieldValue("day", lastDay);
                              } else {
                                setFieldValue("days", days);
                              }
                            }}
                            error={errors.days && touched.days}
                            textError={errors.days}
                          />
                        </div>
                        <div
                          className="col-span-full"
                          style={{ backgroundColor: "#E5EAEE" }}
                        >
                          <p className="text-sm p-5">
                            {t("slots.views.interval_description")}
                          </p>
                        </div>
                        <div className="col-span-full">
                          <DateRangePicker
                            id="date"
                            label={t("lesson.views.interval_date")}
                            disabled={currentEventEdit && !values.all}
                            minDate={new Date()}
                            value={{
                              startDate: values?.date_start
                                ? DateTime.fromFormat(
                                    values?.date_start,
                                    "yyyy-MM-dd"
                                  ).toJSDate()
                                : new Date(),
                              endDate: values?.date_end
                                ? DateTime.fromFormat(
                                    values?.date_end,
                                    "yyyy-MM-dd"
                                  ).toJSDate()
                                : new Date(),
                            }}
                            onDateChange={(startDate, endDate) => {
                              setFieldValue(
                                "date_start",
                                DateTime.fromJSDate(startDate).toFormat(
                                  "yyyy-MM-dd"
                                )
                              );
                              setFieldValue(
                                "date_end",
                                DateTime.fromJSDate(endDate).toFormat(
                                  "yyyy-MM-dd"
                                )
                              );
                            }}
                          />
                        </div>
                        <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                          <InputWithCornerHint
                            label={t("lesson.views.time_init")}
                            name="start_time"
                            id="start_time"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.start_time}
                            error={touched?.start_time && errors?.start_time}
                            textError={errors?.start_time}
                          />
                          <InputWithCornerHint
                            label={t("lesson.views.duration")}
                            name="duration"
                            type="number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.duration}
                            error={touched?.duration && errors?.duration}
                            textError={errors?.duration}
                          />
                        </div>
                        {currentEventEdit && (
                          <div className="col-span-full">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={checkAllEvents}
                                  onChange={() => {
                                    setCheckAllEvents(!checkAllEvents);
                                  }}
                                  name="all"
                                  type="checkbox"
                                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                                  onBlur={handleBlur}
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label
                                  htmlFor=""
                                  className="font-medium text-gray-900"
                                >
                                  Este evento y los posteriores
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG NUEVA ACTIVIDAD */}

        {/*DIALOG HORAS*/}
        <Formik
          enableReinitialize
          onSubmit={(values: SlotsTimesValues, formikHelpers) => {
            updateBranchHours({
              ...values,
              type: "slots",
              branchId: id,
            });
            functionOpenDialogTime();
          }}
          initialValues={slotsTimesValues ?? slotsTimesInitialValues}
          validationSchema={slotsTimesValidationSchema}
        >
          {({ handleChange, handleSubmit, values, errors }) => (
            <DialogCreate
              open={openDialogTime}
              setOpen={functionOpenDialogTime}
              tittle={t("slots.views.time")}
              subTittle={t("slots.views.cancellation_title")}
              tittleButtonCreate={t("general.create")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={functionOpenDialogTime}
            >
              <form action="">
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("slots.views.time")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("slots.views.cancellation_description")}
                            span={t("general.mandatory")}
                            name="hours"
                            type="number"
                            placeholder=""
                            onChange={handleChange}
                            error={!!errors.hours}
                            textError={errors.hours}
                            value={values.hours}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG HORAS*/}

        {/*MODAL TABLE FESTIVOS*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalFestivos}
          open={openModalFestivos}
          tittleModal={t("lesson.views.festivos")}
          functionButtonTopCreate={functionOpenDialogFestivos}
          textButtonClose={t("general.close")}
          modalClassName="z-50"
        >
          <TableListFestivos
            openModal={functionOpenDialogFestivos}
            optionsFestivos={holidaysQuery.data}
            onDelete={async (holiday) => {
              try {
                await deleteHoliday(holiday).unwrap();
                toasts.success(
                  "Eliminación exitosa",
                  "El festivo se ha eliminado correctamente"
                );
                functionOpenModalFestivos();
              } catch (error) {
                toasts.danger(
                  "Error al eliminar",
                  "Ha ocurrido un error al eliminar el festivo"
                );
              }
            }}
            onEdit={(holiday) => {
              setCurrentHolidayEdit({
                ...holiday,
                time_start: holiday.timeStart,
                time_end: holiday.timeEnd,
              });
              functionOpenDialogEditFestivos();
            }}
          />
        </ModalXXL>

        {/*DIALOG CREATE FESTIVOS*/}
        <Formik
          enableReinitialize
          initialValues={holidaysInitialValues}
          validationSchema={holidaysValidationSchema}
          onSubmit={async (values, formikHelpers) => {
            try {
              await createHoliday({
                ...values,
                branchId: id,
              }).unwrap();
              functionOpenModalFestivos();
              functionOpenDialogFestivos();
              formikHelpers.resetForm();
              toasts.success(
                "Registro exitoso",
                "El festivo se ha registrado correctamente"
              );
            } catch (error) {
              console.log("error", error);
              toasts.danger(
                "Error al registrar",
                "Ha ocurrido un error al registrar el festivo"
              );
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
            resetForm,
            setFieldValue,
          }) => {
            return (
              <DialogCreate
                open={openDialogFestivos}
                setOpen={functionOpenDialogFestivos}
                tittle={t("lesson.views.festivos")}
                subTittle={t("lesson.views.creation_festivos")}
                tittleButtonCreate={t("general.create")}
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                isLoading={createHolidayResult.isLoading}
                acceptDisabled={createHolidayResult.isLoading}
                OnclickCancel={() => {
                  functionOpenDialogFestivos();
                  setCurrentHolidayEdit(undefined);
                  resetForm();
                }}
                onClose={() => {
                  functionOpenDialogFestivos();
                  setCurrentHolidayEdit(undefined);
                  resetForm();
                }}
              >
                <form>
                  <div className="mt-6 mx-2">
                    <div className="space-y-12">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.caracteristics")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.festivo")}
                              span={t("general.mandatory")}
                              id="description"
                              name="description"
                              type="text"
                              placeholder={t("lesson.views.festivo")}
                              onChange={handleChange}
                              error={errors?.description}
                              textError={
                                touched?.description && errors?.description
                              }
                              value={values?.description}
                            />
                          </div>
                          <div className="col-span-full">
                            <Select
                              selected={optionSelectFestivos.find(
                                (option) => option.name === values.type
                              )}
                              setSelected={(selected) => {
                                setFieldValue("type", selected?.name);
                              }}
                              options={optionSelectFestivos}
                              tittle={t("lesson.views.type")}
                              error={errors?.type && touched?.type}
                              textError={errors?.type}
                              value={values?.type}
                              span={t("general.mandatory")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.calendaring")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.date")}
                              span={t("general.mandatory")}
                              id="date"
                              name="date"
                              type="date"
                              onChange={handleChange}
                              error={touched?.date && !!errors?.date}
                              textError={touched?.date && errors?.date}
                              value={values?.date}
                            />
                          </div>
                          <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                            <InputWithCornerHint
                              label={t("lesson.views.time_init")}
                              span=""
                              id="time_start"
                              name="time_start"
                              type="time"
                              placeholder=""
                              onChange={handleChange}
                              error={errors?.time_start && touched?.time_start}
                              textError={errors?.time_start}
                              value={values?.time_start}
                            />
                            <InputWithCornerHint
                              label={t("lesson.views.time_end")}
                              span=""
                              id="time_end"
                              name="time_end"
                              type="time"
                              placeholder=""
                              onChange={handleChange}
                              error={errors?.time_end && touched?.time_end}
                              textError={errors?.time_end}
                              value={values?.time_end}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </DialogCreate>
            );
          }}
        </Formik>
        {/*FIN DIALOG FESTIVOS*/}

        {/*DIALOG EDIT FESTIVOS*/}
        <Formik
          enableReinitialize
          initialValues={currentHolidayEdit}
          validationSchema={holidaysValidationSchema}
          onSubmit={async (values, formikHelpers) => {
            try {
              await updateHoliday({
                ...values,
                branchId: id,
              }).unwrap();
              functionOpenModalFestivos();
              functionOpenDialogEditFestivos();
              setCurrentHolidayEdit(undefined);
              toasts.success(
                "Actualización exitosa",
                "El festivo se ha actualizado correctamente"
              );
              formikHelpers.resetForm();
            } catch (error) {
              console.log("error", error);
              toasts.danger(
                "Error al actualizar",
                "Ha ocurrido un error al actualizar el festivo"
              );
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
            resetForm,
            handleBlur,
            setFieldValue,
          }) => {
            return (
              <DialogCreate
                open={openDialogEditFestivos}
                setOpen={functionOpenDialogEditFestivos}
                tittle={t("lesson.views.festivos")}
                subTittle={"Edición de festivos"}
                tittleButtonCreate={t("general.edit")}
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                isLoading={updateHolidayResult.isLoading}
                acceptDisabled={updateHolidayResult.isLoading}
                OnclickCancel={() => {
                  functionOpenDialogEditFestivos();
                  setCurrentHolidayEdit(undefined);
                  resetForm();
                }}
                onClose={() => {
                  functionOpenDialogEditFestivos();
                  setCurrentHolidayEdit(undefined);
                  resetForm();
                }}
              >
                <form>
                  <div className="mt-6 mx-2">
                    <div className="space-y-12">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.caracteristics")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.festivo")}
                              span={t("general.mandatory")}
                              id="description"
                              name="description"
                              type="text"
                              placeholder={t("lesson.views.festivo")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={
                                touched.description && !!errors.description
                              }
                              textError={
                                touched.description && errors.description
                              }
                              value={values?.description}
                            />
                          </div>
                          <div className="col-span-full">
                            <Select
                              selected={optionSelectFestivos.find(
                                (option) => option.name === values?.type
                              )}
                              setSelected={(selected) => {
                                setFieldValue("type", selected?.name);
                              }}
                              options={optionSelectFestivos}
                              tittle={t("lesson.views.type")}
                              error={errors?.type && touched?.type}
                              textError={errors?.type}
                              value={values?.type}
                              span={t("general.mandatory")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.calendaring")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.date")}
                              span={t("general.mandatory")}
                              id="date"
                              name="date"
                              type="date"
                              onChange={handleChange}
                              error={touched?.date && !!errors?.date}
                              textError={touched?.date && errors?.date}
                              value={values?.date}
                            />
                          </div>
                          <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                            <InputWithCornerHint
                              label={t("lesson.views.time_init")}
                              span=""
                              id="time_start"
                              name="time_start"
                              type="time"
                              placeholder=""
                              onChange={handleChange}
                              error={errors?.time_start && touched?.time_start}
                              textError={errors?.time_start}
                              value={values?.time_start}
                            />
                            <InputWithCornerHint
                              label={t("lesson.views.time_end")}
                              span=""
                              id="time_end"
                              name="time_end"
                              type="time"
                              placeholder=""
                              onChange={handleChange}
                              error={errors?.time_end && touched?.time_end}
                              textError={errors?.time_end}
                              value={values?.time_end}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </DialogCreate>
            );
          }}
        </Formik>
        {/*FIN DIALOG FESTIVOS*/}

        {/*MODAL GRUPOS*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalGrupos}
          open={openModalGrupos}
          tittleModal={t("lesson.views.groups")}
          functionButtonTopCreate={functionOpenDialogGrupos}
          textButtonClose={t("general.close")}
          canCreate={can(
            Permission.BRANCH_ACCESS_CREATE_EDIT_DELETE_PHYSICAL_SPACES
          )}
          modalClassName="z-50"
        >
          <TableListGrupos
            editGroups={(group) => {
              functionOpenDialogGrupos();
              setCurrentGroupEdit(group);
            }}
            onDelete={(groupID) => {
              handleOpenDeleteGroup(groupID);
            }}
            optionsGroup={listGroupsQuery.data ?? []}
          />
        </ModalXXL>
        {/*FIN MODAL GRUPOS*/}

        {/*DIALOG CREATE/EDIT GRUPOS*/}
        <Formik
          initialValues={
            currentGroupEdit
              ? {
                  ...currentGroupEdit,
                  description: currentGroupEdit?.description,
                  color: currentGroupEdit?.color?.toUpperCase(),
                  slots_from_group: currentGroupEdit?.slot_places?.map(
                    (place) => place.name
                  ),
                  slot_input: "",
                  name: currentGroupEdit?.name,
                }
              : {
                  name: "",
                  description: "",
                  color: "#A7BED3",
                  slots_from_group: [],
                  slot_input: "",
                }
          }
          enableReinitialize
          validationSchema={Yup.object({
            name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
            description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
            color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
            slots_from_group: Yup.array().of(Yup.string().optional()),
            slot_input: Yup.string().optional(),
          })}
          onSubmit={async (values, formikHelpers) => {
            try {
              const finalValues = {
                name: values.name,
                description: values.description,
                color: values.color,
                places: values?.slot_input.trim()
                  ? [
                      ...(values?.slots_from_group || []),
                      values?.slot_input.trim(),
                    ]
                  : values?.slots_from_group,
              };

              if (currentGroupEdit) {
                await updateGroup({
                  ...finalValues,
                  branchId: id,
                  slot_group_id: currentGroupEdit.id,
                }).unwrap();
                toasts.success(
                  "Actualización exitosa",
                  "El grupo se ha actualizado correctamente"
                );
                listGroupsQuery.refetch();
                slotsPlacesQuery.refetch();
                setCurrentGroupEdit(undefined);
              } else {
                await createGroup({ ...finalValues, branchId: id }).unwrap();
                toasts.success(
                  "Registro exitoso",
                  "El grupo se ha registrado correctamente"
                );
                listGroupsQuery.refetch();
                slotsPlacesQuery.refetch();
                setCurrentGroupEdit(undefined);
              }
              formikHelpers.resetForm();
              functionOpenDialogGrupos();
              functionOpenModalGrupos();
            } catch (error) {
              console.error(error);
              toasts.danger(
                "Error al registrar",
                "Ha ocurrido un error al registrar el grupo"
              );
            }
          }}
        >
          {({
            handleChange,
            values,
            errors,
            resetForm,
            setFieldValue,
            handleSubmit,
          }) => (
            <DialogCreate
              open={openDialogGrupos}
              setOpen={() => {
                functionOpenDialogGrupos();
                resetForm();
              }}
              tittle={
                currentGroupEdit
                  ? t("lesson.views.edit_group")
                  : t("lesson.views.create_group")
              }
              subTittle={null}
              tittleButtonCreate={
                currentGroupEdit ? t("general.edit") : t("general.create")
              }
              tittleButtonCancel={t("general.cancel")}
              onClose={() => {
                functionOpenDialogGrupos();
                resetForm();
              }}
              OnclickCreate={handleSubmit}
              isLoading={
                createGroupResult.isLoading || updateGroupResult.isLoading
              }
              acceptDisabled={
                createGroupResult.isLoading || updateGroupResult.isLoading
              }
              OnclickCancel={() => {
                functionOpenDialogGrupos();
                resetForm();
              }}
            >
              <div>
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.groups")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.name")}
                            span={t("general.mandatory")}
                            id="name"
                            name="name"
                            type="text"
                            placeholder={t("lesson.views.name")}
                            onChange={handleChange}
                            value={values?.name}
                            error={false}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.description")}
                            span={t("general.mandatory")}
                            id="description"
                            name="description"
                            type="text"
                            placeholder={t("lesson.views.description")}
                            onChange={handleChange}
                            value={values?.description}
                            error={false}
                          />
                        </div>
                        <div className="col-span-full">
                          <SelectColor
                            options={colors}
                            span={null}
                            tittle={t("lesson.views.color")}
                            selected={colors.find(
                              (option) => option?.color == values?.color
                            )}
                            setSelected={(selected) => {
                              setFieldValue("color", selected?.color);
                            }}
                            error={!!errors.color}
                            textError={errors.color}
                          />
                        </div>
                        <div className="col-span-full">
                          <div className="flex items-center gap-2">
                            <InputWithCornerHint
                              type="text"
                              id="slot_input"
                              label={t("slots.views.slots_from_group")}
                              name="slot_input"
                              placeholder="Nuevo espacio"
                              value={values.slot_input}
                              onChange={(e) =>
                                setFieldValue("slot_input", e.target.value)
                              }
                              className="flex-1"
                            />
                            <button
                              type="button"
                              className="bg-gray-300 mt-6 text-white p-2 rounded"
                              onClick={() => {
                                if (values.slot_input.trim() !== "") {
                                  setFieldValue("slots_from_group", [
                                    ...values.slots_from_group,
                                    values.slot_input.trim(),
                                  ]);
                                  setFieldValue("slot_input", ""); // limpiar input
                                }
                              }}
                            >
                              <PlusCircleIcon
                                aria-hidden="true"
                                className="h-5 w-5"
                              />
                            </button>
                          </div>

                          {values?.slots_from_group?.map((slot, idx) => (
                            <div
                              key={idx}
                              className="flex items-center mt-3 justify-between bg-gray-100 px-4 py-2 mb-2"
                            >
                              <span>{slot}</span>
                              <button
                                type="button"
                                className="text-white p-2 rounded"
                                onClick={() => {
                                  const updated =
                                    values.slots_from_group.filter(
                                      (_, i) => i !== idx
                                    );
                                  setFieldValue("slots_from_group", updated);
                                }}
                              >
                                <Trash2Icon className="h-5 w-5 text-red-500" />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          )}
        </Formik>
        {/*DIALOG CREATE/EDIT GRUPOS */}

        {/* DELETE GROUP ESPACIOS */}
        <AlertErrorButtons
          open={openDeleteGroup}
          onClose={() => setOpenDeleteGroup(false)}
          title={"Eliminar grupo"}
          message={
            "¿Confirmas que quieres eliminar este grupo de espacio? Ten en cuenta que no se borrará ninguno de los eventos ya creados."
          }
          primaryButtonText={t("general.delete")}
          secondaryButtonText={t("general.cancel")}
          onPrimaryButtonClick={async () => {
            try {
              await deleteGroup({
                branchId: id,
                id: currentGroupToDeleteId,
              }).unwrap();
              toasts.success(
                "Grupo eliminado",
                "El grupo se ha eliminado correctamente"
              );
              listGroupsQuery.refetch();
              setOpenDeleteGroup(false);
              setCurrentGroupToDeleteId(null);
            } catch (error) {
              toasts.danger(
                "Error al eliminar",
                "Ha ocurrido un error al eliminar el grupo"
              );
              console.error(error);
            }
          }}
          onSecondaryButtonClick={() => setOpenDeleteGroup(false)}
          isLoading={deleteGroupResult.isLoading}
        />

        {/*MODAL XXL*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalActividades}
          open={openModalActividades}
          tittleModal={t("lesson.views.activity")}
          textButtonClose={t("general.close")}
          functionButtonDelete={() => {}}
          functionButtonEdit={() => {}}
        >
          <div className="flex flex-col sm:flex-row">
            {/* Columna Izquierda */}
            <div className="w-full sm:w-1/2 p-4">
              <div>
                <div className="px-4 sm:px-0">
                  <h3 className="text-base font-semibold leading-7 text-gray-900">
                    Actividad de Nutricion
                  </h3>
                  <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                    Consulta con nutricionista.
                  </p>
                </div>
                <div className="mt-6 border-t border-gray-100">
                  <dl className="divide-y divide-gray-100">
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.ocupation")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        Ejemplo
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.date_duration")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        8-9-2024 (60 min)
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.specialist")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        Nutricionista
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.room")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        Sala 1
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>

            {/* Columna Derecha */}
            <div className="w-full sm:w-1/2 p-4">
              <TableListUsersActivitys optionsUsers={optionsTableUsers} />
            </div>
          </div>
        </ModalXXL>
        {/*FIN MODAL XXL */}

        {/*MODAL TABLE BONOS*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalBonos}
          open={openModalBonos}
          tittleModal={t("slots.views.bonds")}
          functionButtonTopCreate={functionOpenDialogCreateBonos}
          textButtonClose={t("general.close")}
          //functionButtonHabilitarCoutas={() => {}} // Se comenta mientras se configura todo el tema de pagos a nivel de filial -> by ETBGM03
          canCreate={can(Permission.BRANCH_ACCESS_CREATE_EDIT_SPACE_BONUSES)}
          modalClassName="z-50"
        >
          <TableListBonos
            bonos={
              slotBondsQuery?.data?.map((bond) => ({
                ...bond,
                groupbond: { name: bond?.slot_bond_group?.name },
              })) || []
            }
            functionButtonPause={handleActivateDeactivateBond}
            functionButtonEdit={(bond) => {
              setCurrentBondEdit(bond);
              setShowAlertBondEdit(true);
            }}
            functionButtonDelete={(bond) => {
              setCurrentBondEdit(bond);
              setShowAlertBondDelete(true);
            }}
            canEdit={can(Permission.BRANCH_ACCESS_CREATE_EDIT_SPACE_BONUSES)}
            canDelete={can(Permission.BRANCH_ACCESS_DELETE_SPACE_BONUSES)}
          />
        </ModalXXL>
        {/*FIN MODAL TABLE BONOS*/}

        {/*DIALOG CREATE/EDIT BONOS */}
        <Formik
          enableReinitialize
          validationSchema={slotBondValidationSchema}
          initialValues={
            currentBondEdit
              ? {
                  ...currentBondEdit,
                  type_slot: currentBondEdit.wallet === 0 ? false : true,
                  branch_slot_bond: currentBondEdit.only_for_center,
                  repeated_bonus:
                    currentBondEdit.repeated_bonus === 0 ? false : true,
                  groupbond_id: currentBondEdit.groupbond_id ?? null,
                  nameGroupBond: currentBondEdit.slot_bond_group?.name ?? "",
                }
              : initialValuesSlotBond
          }
          onSubmit={async (values, formikHelpers) => {
            try {
              if (currentBondEdit) {
                await updateSlotBond({
                  ...values,
                  type_slot: values.type_slot ? 1 : 0,
                  branch_slot_bond: values.branch_slot_bond ? "on" : "off",
                  repeated_bonus: values.repeated_bonus ? "on" : "off",
                  branchId: id,
                  bondId: currentBondEdit.id,
                }).unwrap();
                toasts.success(
                  "Bono actualizado",
                  "El bono se ha actualizado correctamente"
                );
              } else {
                await createSlotBond({
                  ...values,
                  type_slot: values.type_slot ? "on" : "off",
                  branch_slot_bond: values.branch_slot_bond ? "on" : "off",
                  branchId: id,
                }).unwrap();
                toasts.success(
                  "Bono creado",
                  "El bono se ha creado correctamente"
                );
              }
              functionOpenDialogCreateBonos();
              functionOpenModalBonos();
              slotBondsQuery.refetch();
              formikHelpers.resetForm();
            } catch (error) {
              console.log("error", error);
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
            setFieldValue,
            resetForm,
          }) => (
            <DialogCreate
              open={openDialogCreateBonos}
              setOpen={() => {
                functionOpenDialogCreateBonos();
                resetForm();
                setCurrentBondEdit(undefined);
              }}
              tittle={t("lesson.views.bond")}
              subTittle={t("slots.views.create_bond")}
              tittleButtonCreate={
                currentBondEdit ? t("general.edit") : t("general.create")
              }
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => {
                functionOpenDialogCreateBonos();
                resetForm();
                setCurrentBondEdit(undefined);
              }}
              onClose={() => {
                functionOpenDialogCreateBonos();
                resetForm();
                setCurrentBondEdit(undefined);
              }}
              isLoading={
                createSlotBondResult.isLoading || updateSlotBondResult.isLoading
              }
              acceptDisabled={
                createSlotBondResult.isLoading || updateSlotBondResult.isLoading
              }
            >
              <form>
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("slots.views.caracteristics")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        {!currentBondEdit && (
                          <div className="col-span-full flex justify-center">
                            <ToggleText
                              checked={values.type_slot}
                              onChange={() =>
                                setFieldValue("type_slot", !values.type_slot)
                              }
                              texto={
                                values.type_slot === false
                                  ? t("slots.views.session")
                                  : t("slots.views.monedero")
                              }
                              textoSecondary=""
                            />
                          </div>
                        )}
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("slots.views.name")}
                            name="name"
                            type="text"
                            placeholder={t("slots.views.name")}
                            onChange={handleChange}
                            value={values.name}
                            error={!!errors.name}
                            textError={errors.name}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("slots.views.description_edit")}
                            name="description"
                            type="text"
                            placeholder={t("slots.views.description_edit")}
                            onChange={handleChange}
                            value={values.description}
                            error={!!errors.description}
                            textError={errors.description}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("slots.views.price")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputDropDownSpan
                            label={t("slots.views.price")}
                            span={t("general.mandatory")}
                            name="price"
                            type="number"
                            placeholder={t("slots.views.price")}
                            onChange={(e) => {
                              const value = parseFloat(e.target.value);
                              handleChange({
                                target: {
                                  name: e.target.name,
                                  value: isNaN(value) ? "" : value,
                                },
                              });
                            }}
                            value={values.price}
                            nameSelect="currency"
                            selectValue={values.currency?.toUpperCase()}
                            onSelectChange={handleChange}
                            options={currencies.map((item) => ({
                              ...item,
                              id: item.currency,
                              text: item.currency,
                            }))}
                            error={
                              (touched.price && !!errors.price) ||
                              (touched.currency && !!errors.currency)
                            }
                            textError={
                              (touched.price && errors.price) ||
                              (touched.currency && errors.currency)
                            }
                          />
                        </div>
                        {!values.type_slot && (
                          <div className="col-span-full">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.branch_slot_bond}
                                  onChange={() =>
                                    setFieldValue(
                                      "branch_slot_bond",
                                      !values.branch_slot_bond
                                    )
                                  }
                                  name="branch_slot_bond"
                                  id="branch_slot_bond"
                                  type="checkbox"
                                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-indigo-600"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label className="font-medium text-gray-900">
                                  {t("slots.views.checkBonoCenter")}
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                          {!values.type_slot && (
                            <div className="mt-6">
                              <InputWithCornerHint
                                label={t("slots.views.session")}
                                name="session"
                                type="number"
                                placeholder=""
                                onChange={handleChange}
                                value={
                                  values.branch_slot_bond ? 1 : values.session
                                }
                                error={!!errors.session}
                                textError={errors.session}
                              />
                            </div>
                          )}
                          <InputWithCornerHint
                            label={t("slots.views.days_caducity_description")}
                            name="days"
                            type="text"
                            placeholder=""
                            onChange={handleChange}
                            value={
                              values.branch_slot_bond
                                ? values.days
                                : values.days
                            }
                            error={!!errors.days}
                            textError={errors.days}
                          />
                        </div>
                        {!values.type_slot && !values.branch_slot_bond && (
                          <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                            <div
                              className="relative flex items-start"
                              style={{
                                marginTop: values.repeated_bonus ? "40%" : "",
                              }}
                            >
                              <div className="flex h-6 items-center">
                                <input
                                  checked={values.repeated_bonus}
                                  onChange={() =>
                                    setFieldValue(
                                      "repeated_bonus",
                                      !values.repeated_bonus
                                    )
                                  }
                                  name="repeated_bonus"
                                  id="repeated_bonus"
                                  type="checkbox"
                                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-indigo-600"
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label className="font-medium text-gray-900">
                                  {t("slots.views.session_acum")}
                                </label>
                              </div>
                            </div>
                            {values.repeated_bonus && (
                              <InputWithCornerHint
                                label={t("slots.views.max_session")}
                                name="max_session"
                                type="text"
                                placeholder=""
                                onChange={handleChange}
                                value={values.max_session}
                                error={!!errors.max_session}
                                textError={errors.max_session}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    {!values.type_slot && !values.branch_slot_bond && (
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("slots.views.group_bond")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full w-full items-center gap-6">
                            <InputWithCornerHint
                              label={t("slots.views.write_bond")}
                              name="nameGroupBond"
                              type="text"
                              placeholder=""
                              className="w-full"
                              onChange={handleChange}
                              value={values.nameGroupBond}
                              error={!!errors.nameGroupBond}
                              textError={errors.nameGroupBond}
                            />
                            <div className="text-center my-4 text-gray-900 font-semibold">
                              {t("slots.views.o")}
                            </div>
                            <div className="col-span-full">
                              <Select
                                name="groupbond_id"
                                span={
                                  values.nameGroupBond
                                    ? t("general.optional")
                                    : t("general.mandatory")
                                }
                                selected={slotBondGroups?.find(
                                  (option: any) =>
                                    option.id === Number(values.groupbond_id)
                                )}
                                setSelected={(selected) =>
                                  setFieldValue("groupbond_id", selected.id)
                                }
                                options={slotBondGroups as any}
                                tittle={t("slots.views.select_group_bond")}
                                value={values.groupbond_id}
                                error={!!errors.groupbond_id}
                                textError={errors.groupbond_id}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG CREATE/EDIT BONOS */}
      </div>

      <AlertErrorButtons
        open={showAlertBondEdit}
        onPrimaryButtonClick={() => {
          setShowAlertBondEdit(false);
          functionOpenDialogCreateBonos();
        }}
        onSecondaryButtonClick={() => {
          setShowAlertBondEdit(false);
          setCurrentBondEdit(undefined);
        }}
        onClose={() => setShowAlertBondEdit(false)}
        title={"Bonos de espacios"}
        message={
          "¿Estás seguro de que quieres modificarla? Esto afectará de inmediato a todos los usuarios a los que se les haya asignado esta cuota, y los próximos cobros podrían verse afectados"
        }
        primaryButtonText={t("general.edit")}
        secondaryButtonText={t("general.cancel")}
      />

      <AlertErrorButtons
        open={showAlertBondDelete}
        onPrimaryButtonClick={handleDeleteBondGroupSlot}
        onSecondaryButtonClick={() => {
          setShowAlertBondDelete(false);
        }}
        onClose={() => setShowAlertBondDelete(false)}
        title={"Bonos de espacios"}
        message={
          "¿Estás seguro de que deseas borrarla? Todos los usuarios con esta cuota dejarán de tenerla, y también se eliminará el historial de cobros relacionados. Te recomendamos que no la borres, y en su lugar, la desactives."
        }
        primaryButtonText={t("general.delete")}
        secondaryButtonText={t("general.cancel")}
      />

      {/*MODAL XXL*/}
      <ModalXXL
        onClickCreate={() => {}}
        Close={() => setCurrentEvent(undefined)}
        open={!!currentEvent}
        tittleModal={t("lesson.views.activity")}
        textButtonClose={t("general.close")}
        functionButtonDelete={() => {
          setCurrentEventToDelete(currentEvent?.id);
          setOpenDeleteEvent(true);
        }}
        functionButtonEdit={() => {
          setCurrentEventEdit(currentEvent);
          setOpenDialogCreate(true);
        }}
        canEdit={can(Permission.BRANCH_ACCESS_EDIT_SPACES)}
        canDelete={can(Permission.BRANCH_ACCESS_DELETE_SPACES)}
      >
        <div className="flex flex-col sm:flex-row">
          {/* Columna Izquierda */}
          <div className="w-full p-4">
            <div>
              <div className="px-4 sm:px-0">
                <h3 className="text-base font-semibold leading-7 text-gray-900">
                  {currentEvent?.name}
                </h3>
                <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                  {currentEvent?.description}
                </p>
              </div>
              <div className="mt-6 border-t border-gray-100">
                <dl className="divide-y divide-gray-100">
                  <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium leading-6 text-gray-900">
                      {t("lesson.views.date_duration")}
                    </dt>
                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                      {currentEvent?.date} ({currentEvent?.duration} min)
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </ModalXXL>

      {/*MODAL DELETE EVENT XXL*/}
      <Modal
        Close={() => setOpenDeleteEvent(false)}
        open={openDeleteEvent}
        tittleModal={""}
        onClickCreate={async () => {
          try {
            await deleteSlot({
              id: currentEventToDelete,
              branchId: id,
              all: deleteAllEvents,
            }).unwrap();
            setOpenDeleteEvent(false);
            setDeleteAllEvents(false);
            setCurrentEvent(undefined);
            toasts.success(
              "Eliminación exitosa",
              "El evento se ha eliminado correctamente"
            );
            slotsQuery.refetch();
          } catch (error) {
            console.error(error);
            toasts.danger(
              "Error al eliminar",
              "Ha ocurrido un error al eliminar el evento"
            );
          }
        }}
        textButtonCreate={t("general.delete")}
        textButtonClose={t("general.close")}
        loader={deleteSlotResult.isLoading}
      >
        <div>
          <h2 className="text-2xl font-semibold">Cuidado</h2>
          <div className="mt-4 ">
            <p>
              Si deseas eliminar todos los eventos posteriores que pertenecen a
              este mismo espacio
            </p>
          </div>
          <div className="mt-4 flex items-center gap-2">
            <label
              className="flex items-center cursor-pointer select-none"
              htmlFor="deleteAllEventsCheckbox"
            >
              <Input
                id="deleteAllEventsCheckbox"
                checked={deleteAllEvents}
                onChange={() => setDeleteAllEvents(!deleteAllEvents)}
                type="checkbox"
                className="flex"
                label=""
                aria-checked={deleteAllEvents}
              />
              <span className="ml-2">
                Eliminar este evento y los posteriores
              </span>
            </label>
          </div>
        </div>

        <div className="mt-4">
          <span>Está seguro que desea eliminar?</span>
        </div>
      </Modal>

      {filters ? (
        <>
          <FiltersCalendar
            filtersOpen={filtersOpen}
            selectedGroups={selectedGroups}
            setSelectedGroups={setSelectedGroups}
            options={listGroupsQuery?.data}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
